import find from 'lodash/find';

import { hasPermission } from './getVideoPermissions';

export default (props) => {
  const { flattenedVideosAdminTree, params } = props;
  const { id: currentTopicId, orgId, type } = params;
  const currentTopic = find(flattenedVideosAdminTree.data, { id: Number(currentTopicId) });

  if (!currentTopic) return [];

  const rootUrl = `/videos/organizations/${orgId}/${type}`;

  const rootCrumb = {
    id: 0,
    name: 'Videos',
    url: rootUrl,
  };

  const currentTopicCrumb = {
    id: currentTopicId,
    name: currentTopic.name,
    url: `${rootUrl}/topics/${currentTopicId}`,
    type: 'topic',
    isDisabled: !currentTopic.has_editor_permission,
  };

  if (!currentTopic.ancestry) return [rootCrumb, currentTopicCrumb];

  const ancestryWithUrls = currentTopic.ancestry.map((ancestor) => {
    const ancestorId = ancestor.id;

    return {
      ...ancestor,
      url: `${rootUrl}/topics/${ancestorId}`,
      type: 'topic',
      isDisabled: !hasPermission({
        ancestorId,
        permission: 'hasAccessToAncestor',
        ...props,
      }),
    };
  });

  return [rootCrumb, ...ancestryWithUrls, currentTopicCrumb];
};
